import { clip, clipToBox, clamp, clamp3D } from "./range.js";

const range = {
  clip,
  clipToBox,
  clamp,
  clamp3D,
};

export default range;
